function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Icon / Bills &amp; Payments / bill_insert");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Icon-/-Bills-&-Payments-/-bill_insert",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("polyline", {
  id: "Path",
  stroke: "#00148C",
  strokeWidth: 2,
  strokeLinejoin: "round",
  points: "37.8694937 41.9365044 58 28 58 59 6 59 6 28 6 28 25.9447549 41.8079072"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Rectangle",
  stroke: "#00148C",
  strokeWidth: 2,
  strokeLinejoin: "round",
  points: "6 52 32 39 58 52 58 59 6 59"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Path",
  stroke: "#00148C",
  strokeWidth: 2,
  strokeLinejoin: "round",
  points: "52.9880859 25.494043 58 28 58 59 6 59 6 28 6 28 11.0158203 25.4920898"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Path",
  stroke: "#00148C",
  strokeLinejoin: "round",
  points: "11 31.5 11 6 11 6 53 6 53 31.5"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  stroke: "#00148C",
  strokeWidth: 2,
  strokeLinejoin: "round",
  x: 16,
  y: 11,
  width: 6,
  height: 6
}), /*#__PURE__*/React.createElement("line", {
  x1: 15,
  y1: 22.642735,
  x2: 40,
  y2: 22.642735,
  id: "Path-9",
  stroke: "#00148C",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  x1: 15,
  y1: 26.642735,
  x2: 45,
  y2: 26.642735,
  id: "Path-9",
  stroke: "#00148C",
  strokeWidth: 2
}));

var SvgBillInsert = function SvgBillInsert(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBillInsert, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bill_insert.c2d8efed.svg";
export { ForwardRef as ReactComponent };